function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 699,
  height: 847,
  rx: 3.5,
  fill: "#fff",
  stroke: "#D4E1EE"
});

var SvgIconWrongAnswer = function SvgIconWrongAnswer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 700 848",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzAwIiBoZWlnaHQ9Ijg0OCIgdmlld0JveD0iMCAwIDcwMCA4NDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iNjk5IiBoZWlnaHQ9Ijg0NyIgcng9IjMuNSIgZmlsbD0id2hpdGUiIHN0cm9rZT0iI0Q0RTFFRSIvPgo8L3N2Zz4K";
export { SvgIconWrongAnswer as ReactComponent };